import type { UnauthenticatedRouteOwnership } from '@gonfalon/router/generated/routeInfo';

export const unauthenticatedRouteOwnership: UnauthenticatedRouteOwnership = {
  '/*': 'team-foundation',
  '/forgot': 'team-billing',
  '/invite/:invitationToken': 'team-foundation',
  '/join': 'team-foundation',
  '/login': 'team-billing',
  '/oauth/google': 'team-foundation',
  '/oauth/github': 'team-foundation',
  '/oauth/vercel': 'team-foundation',
  '/team-uses-sso': 'team-foundation',
  '/reset/:passwordResetToken': 'team-billing',
  '/signup': 'team-foundation',
  '/signup-agentcontrol': 'team-foundation',
  '/signup/:token': 'team-foundation',
  '/join-your-organization/:token': 'team-foundation',
  '/verify-email/:email': 'team-foundation',
  '/check-your-email': 'team-foundation',
  '/choose-organization/:email': 'team-foundation',
  '/choose-organization/verify/:token': 'team-foundation',
  '/choose-organization/verify-email/:email': 'team-foundation',
  '/choose-organization/check-your-email': 'team-foundation',
  '/choose-organization/:email/:selectedOrganization/enter-password': 'team-foundation',
  '/choose-organization/:selectedOrganization/forgot': 'team-foundation',
  '/enroll-mfa': 'team-foundation',
  '/trial-limit': 'team-foundation',
  '/pending-invite/:token': 'team-foundation',
  '/welcome/:token': 'team-foundation',
};
